import React from "react";
import Authentication from "./authentication";

export default function Render(props) {
  return <Authentication {...props} authenticationType={"resetPassword"} />;
}
